import React, { createContext, useContext, useState } from "react";

const SessionIdContext = createContext<{
  loadedSessionIdParam: string | undefined;
  setLoadedSessionIdParam: (id: string | undefined) => void;
}>({
  loadedSessionIdParam: undefined,
  setLoadedSessionIdParam: () => {},
});

export const SessionIdProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loadedSessionIdParam, setLoadedSessionIdParam] = useState<
    string | undefined
  >(undefined);
  return (
    <SessionIdContext.Provider
      value={{ loadedSessionIdParam, setLoadedSessionIdParam }}
    >
      {children}
    </SessionIdContext.Provider>
  );
};

export const useSessionIdContext = (): {
  loadedSessionIdParam: string | undefined;
  setLoadedSessionIdParam: (id: string | undefined) => void;
} => {
  const context = useContext(SessionIdContext);
  if (!context) {
    throw new Error(
      "useSessionIdContext must be used within a SessionIdProvider",
    );
  }
  return context;
};
